import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FreeCompaniesService } from 'src/app/services/free-companies.service';

@Component({
  selector: 'app-allied-id',
  templateUrl: './allied-id.component.html',
  styleUrls: ['./allied-id.component.scss']
})
export class AlliedIdComponent {
  @Output() submitDates = new EventEmitter<{ alliedSelect: string | null }>();
  public alliedList: any[] = [];

  dateForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private freeCompaniesService: FreeCompaniesService,
    private dialogRef: MatDialogRef<AlliedIdComponent>
  ) {
    this.dateForm = this.fb.group({
      alliedSelect: ['']
    });

    this.freeCompaniesService.listFreeAllied().subscribe((rta: any) => {
      this.alliedList = rta.allieds;
    });
  }

  // Método para cerrar el diálogo con el valor seleccionado
  onClose(selectedValue: string | null = null, close_forced = true) {
    this.dialogRef.close({ alliedSelect: selectedValue, close_forced: close_forced }); // Cierra el modal pasando el valor seleccionado
  }

  onSubmit() {
    const { alliedSelect } = this.dateForm.value;

    // Emitir el evento con el valor seleccionado y cerrar el modal pasando el valor
    this.submitDates.emit({
      alliedSelect: alliedSelect
    });
    this.onClose(alliedSelect, false); // Pasa el valor seleccionado al cerrar el modal
  }
}
